module.exports = "pegasus_template/assets/tech/safari/106.png";